import * as yup from 'yup'

export const addPromotionalLP = yup.object({
	promotionalTitle: yup.string().required(),
	promotionalSubtitle: yup.string().required(),
	promotionalText: yup.string().required(),
	promotionalRdStationTag: yup.string().required(),
	promotionalButtonText: yup.string().required(),
})
